import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as itemsActions from 'store/modules/items';

// import ItemMenuTree from 'components/items/ItemMenuTree';

import Adsense970250 from 'components/adsense/Adsense970250';

class MenuTreeContainer extends Component {
  
  render() {
    const {currSelWeapon} = this.props;
    const {currItem} = currSelWeapon;
    const {ITEM_NM} = currItem;
    const style = {
      textAlign: 'center',
      margin: '1em',
      fontSize: '20px',
      fontWeight: '600',
      // borderBottom: '1px solid black'
    }
    const style1 = {
      // fontSize: '20px',
      // fontWeight: '600',
      // paddingBottom: '8px',
      // borderBottom: '1px solid #e5e5e5',
      // marginBottom: '12px'

      fontSize: '20px',
      fontWeight: '600',
      padding: '12px 0',
      marginBottom: '16px',
      borderBottom: '1px solid #ddd'
    }

    return (
      // <ItemMenuTree
      // currSelWeapon={currSelWeapon}
      // />
      <div style={style}>
        
        <div style={style1}>{ITEM_NM} 상세정보</div>

        {/* <Adsense970250/> */}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    currSelWeapon: state.items.toJS().currSelWeapon
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(MenuTreeContainer);